import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function permissionGroupPermissionsFetch(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PERMISSION_GROUP_PERMISSIONS_FETCH,
    () =>
      requestor
        .get(`${basePath}/permission_group_permission`, {
          withCredentials: true,
        })
        .then(response => response.data),
  );
}
